import React, { useState } from 'react';

const App = () => {
  const [cartCount, setCartCount] = useState(0);

  const products = [
    {
      id: 1,
      name: 'Birthday Cake Special',
      price: 25000,
      originalPrice: 30000,
      image: 'https://images.unsplash.com/photo-1578985545062-69928b1d9587?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      rating: 4.8,
      reviews: 124,
      badge: 'Best Seller'
    },
    {
      id: 2,
      name: 'Wedding Cake Deluxe',
      price: 150000,
      originalPrice: 180000,
      image: 'https://images.unsplash.com/photo-1535254973040-607b474cb50d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      rating: 4.9,
      reviews: 86,
      badge: 'Premium'
    },
    {
      id: 3,
      name: 'Cupcakes Pack (12pcs)',
      price: 8000,
      originalPrice: 10000,
      image: 'https://images.unsplash.com/photo-1486427944299-d1955d23e34d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      rating: 4.7,
      reviews: 159,
      badge: 'Popular'
    },
    {
      id: 4,
      name: 'Anniversary Cake',
      price: 35000,
      originalPrice: 40000,
      image: 'https://images.unsplash.com/photo-1535141192574-5d4897c12636?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      rating: 4.9,
      reviews: 78,
      badge: 'Premium'
    },
    {
      id: 5,
      name: 'Party Snacks Pack',
      price: 15000,
      originalPrice: 18000,
      image: 'https://images.unsplash.com/photo-1621743478914-cc8a86d7e9e5?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      rating: 4.5,
      reviews: 97,
      badge: 'Popular'
    },
    {
      id: 6,
      name: 'Corporate Event Catering',
      price: 250000,
      originalPrice: 300000,
      image: 'https://images.unsplash.com/photo-1555244162-803834f70033?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      rating: 4.7,
      reviews: 43,
      badge: 'Premium'
    },
    {
      id: 7,
      name: 'Pastries Assortment',
      price: 12000,
      originalPrice: 15000,
      image: 'https://images.unsplash.com/photo-1483695028939-5bb13f8648b0?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      rating: 4.6,
      reviews: 129,
      badge: 'Best Value'
    },
    {
      id: 8,
      name: 'Custom Theme Cake',
      price: 45000,
      originalPrice: 55000,
      image: 'https://images.unsplash.com/photo-1519654793190-2e8a4806f1f2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      rating: 4.8,
      reviews: 92,
      badge: 'Custom'
    }
  ];

  const addToCart = () => {
    setCartCount(cartCount + 1);
  };

  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-white font-poppins">
      {/* Navigation */}
      <nav className="fixed top-0 w-full bg-white/95 backdrop-blur-lg shadow-lg z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <h1 className="text-2xl font-montserrat font-black text-primary-500 tracking-tight">Seven Cakes & Treats</h1>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <button onClick={() => scrollToSection('home')} className="text-gray-700 hover:text-primary-500 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-300 hover:bg-primary-50">Home</button>
                <button onClick={() => scrollToSection('products')} className="text-gray-700 hover:text-primary-500 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-300 hover:bg-primary-50">Our Menu</button>
                <button onClick={() => scrollToSection('gallery')} className="text-gray-700 hover:text-primary-500 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-300 hover:bg-primary-50">Gallery</button>
                <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-primary-500 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-300 hover:bg-primary-50">Contact</button>
                <button onClick={() => scrollToSection('contact')} className="btn-primary">Order Now</button>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="min-h-screen bg-gradient-to-br from-primary-500 via-orange-500 to-yellow-400 relative overflow-hidden">
        <div className="absolute inset-0 bg-black/10"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-white/10 via-transparent to-white/10"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20">
          <div className="grid lg:grid-cols-2 gap-12 items-center min-h-screen py-20">
            <div className="text-white">
              <div className="inline-block bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-semibold mb-6">
                � Premier Bakery & Catering Service in Abuja
              </div>
              <h1 className="text-5xl lg:text-7xl font-montserrat font-black leading-tight mb-6 tracking-tight">
                Delicious Cakes & Professional Catering
              </h1>
              <p className="text-xl lg:text-2xl mb-8 opacity-95 leading-relaxed max-w-2xl">
                From exquisite wedding cakes to mouthwatering treats - we bring your special occasions to life with our delectable creations. Trusted by countless satisfied customers in Abuja.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <button onClick={() => scrollToSection('products')} className="bg-white text-primary-500 px-8 py-4 rounded-full text-lg font-bold hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300 text-center">
                  View Menu <i className="fas fa-arrow-right ml-2"></i>
                </button>
                <button onClick={() => scrollToSection('contact')} className="border-2 border-white text-white px-8 py-4 rounded-full text-lg font-bold hover:bg-white hover:text-primary-500 transition-all duration-300 text-center">
                  Order Now
                </button>
              </div>
            </div>
            <div className="relative">
              <img src="https://images.unsplash.com/photo-1535141192574-5d4897c12636?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" alt="Beautiful Wedding Cake" className="rounded-3xl shadow-2xl transform hover:scale-105 transition-transform duration-500" />
              <div className="absolute -bottom-6 -left-6 bg-white p-4 rounded-2xl shadow-xl">
                <div className="flex items-center space-x-3">
                  <i className="fas fa-clock text-primary-500 text-2xl"></i>
                  <div>
                    <p className="font-semibold text-gray-800">Custom Orders</p>
                    <p className="text-sm text-gray-600">48hrs Notice</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Banner */}
      <section className="bg-gradient-to-r from-primary-500 to-orange-500 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white mb-12">
            <h2 className="text-3xl font-montserrat font-bold mb-4">Why Customers Love Seven Cakes & Treats</h2>
            <p className="text-xl opacity-90">Abuja's Premier Bakery & Catering Service</p>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center text-white">
              <i className="fas fa-birthday-cake text-4xl mb-4"></i>
              <h3 className="text-lg font-bold mb-2">Premium Quality</h3>
              <p className="opacity-90">Finest ingredients used</p>
            </div>
            <div className="text-center text-white">
              <i className="fas fa-clock text-4xl mb-4"></i>
              <h3 className="text-lg font-bold mb-2">Custom Orders</h3>
              <p className="opacity-90">48hrs turnaround time</p>
            </div>
            <div className="text-center text-white">
              <i className="fas fa-utensils text-4xl mb-4"></i>
              <h3 className="text-lg font-bold mb-2">Full Catering</h3>
              <p className="opacity-90">Professional service</p>
            </div>
            <div className="text-center text-white">
              <i className="fas fa-map-marker-alt text-4xl mb-4"></i>
              <h3 className="text-lg font-bold mb-2">Location</h3>
              <p className="opacity-90">Clobek Estate, Lugbe</p>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section id="products" className="py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-montserrat font-bold text-gray-900 mb-4">Our Menu & Services</h2>
            <p className="text-xl text-gray-600">Delicious treats for every occasion</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {products.map((product) => (
              <div key={product.id} className="bg-white rounded-3xl shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-500 overflow-hidden group">
                <div className="relative">
                  <img src={product.image} alt={product.name} className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500" />
                  <div className={`absolute top-4 left-4 px-3 py-1 rounded-full text-sm font-semibold text-white ${
                    product.badge === 'Best Seller' ? 'bg-primary-500' :
                    product.badge === 'Premium' ? 'bg-purple-600' :
                    product.badge === 'New' ? 'bg-green-600' :
                    product.badge === 'Popular' ? 'bg-blue-600' :
                    product.badge === 'Sale' ? 'bg-red-600' : 'bg-gray-600'
                  }`}>
                    {product.badge}
                  </div>
                </div>
                <div className="p-6">
                  <div className="flex items-center mb-3">
                    <div className="text-yellow-400">
                      {'★'.repeat(Math.floor(product.rating))}{'☆'.repeat(5 - Math.floor(product.rating))}
                    </div>
                    <span className="text-gray-600 ml-2">({product.reviews} reviews)</span>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{product.name}</h3>
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center space-x-2">
                      <span className="text-2xl font-bold text-primary-500">₵{product.price}</span>
                      {product.originalPrice && (
                        <span className="text-gray-500 line-through">₵{product.originalPrice}</span>
                      )}
                    </div>
                    {product.originalPrice && (
                      <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-sm font-semibold">
                        {Math.round((1 - product.price / product.originalPrice) * 100)}% OFF
                      </span>
                    )}
                  </div>
                  <button onClick={() => scrollToSection('contact')} className="w-full btn-primary">
                    Learn More
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section id="gallery" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-montserrat font-bold text-gray-900 mb-4">Our Gallery</h2>
            <p className="text-xl text-gray-600">A showcase of our delicious creations</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="lg:col-span-2 lg:row-span-2">
              <img src="https://images.unsplash.com/photo-1535254973040-607b474cb50d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Wedding Cake" className="w-full h-full object-cover rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300" />
            </div>
            <div>
              <img src="https://images.unsplash.com/photo-1557979619-445218f326b9?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="Birthday Cake" className="w-full h-48 object-cover rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300" />
            </div>
            <div>
              <img src="https://images.unsplash.com/photo-1488477304112-4944851de03d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="Cupcakes" className="w-full h-48 object-cover rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300" />
            </div>
            <div>
              <img src="https://images.unsplash.com/photo-1621303837174-89787a7d4729?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="Party Snacks" className="w-full h-48 object-cover rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300" />
            </div>
            <div>
              <img src="https://images.unsplash.com/photo-1562777717-dc6984f65a63?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="Pastries" className="w-full h-48 object-cover rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300" />
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-20 bg-gradient-to-r from-primary-500 to-orange-500 relative overflow-hidden">
        <div className="absolute inset-0 bg-black/10"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="text-white">
              <h2 className="text-4xl font-montserrat font-bold mb-6">Abuja's Finest Bakery & Catering Service</h2>
              <p className="text-xl mb-8 opacity-95 leading-relaxed">
                At Seven Cakes & Treats, we specialize in creating delightful baked goods and providing professional catering services. From elegant wedding cakes to delicious party treats, we bring your special occasions to life with our culinary expertise.
              </p>
              <div className="grid grid-cols-2 gap-8">
                <div className="text-center">
                  <h3 className="text-4xl font-bold mb-2">5+</h3>
                  <p className="opacity-90">Years Experience</p>
                </div>
                <div className="text-center">
                  <h3 className="text-4xl font-bold mb-2">1000+</h3>
                  <p className="opacity-90">Happy Customers</p>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <img src="https://images.unsplash.com/photo-1557979619-445218f326b9?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="Birthday Cake" className="w-full h-40 object-cover rounded-2xl shadow-lg" />
                <img src="https://images.unsplash.com/photo-1621303837174-89787a7d4729?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="Party Snacks" className="w-full h-32 object-cover rounded-2xl shadow-lg" />
              </div>
              <div className="pt-8">
                <img src="https://images.unsplash.com/photo-1535254973040-607b474cb50d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="Wedding Cake" className="w-full h-48 object-cover rounded-2xl shadow-lg" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 bg-gradient-to-b from-gray-900 to-black relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-primary-500/10 via-transparent to-orange-500/10"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-montserrat font-bold text-white mb-4">Get In Touch</h2>
            <p className="text-xl text-gray-300">Order your delicious treats or discuss catering services</p>
          </div>
          <div className="grid lg:grid-cols-3 gap-8">
            <div className="bg-white/10 backdrop-blur-lg p-8 rounded-3xl text-center text-white hover:bg-white/15 transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-primary-500/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="fas fa-map-marker-alt text-primary-500 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold mb-4">Visit Our Store</h3>
              <p className="text-gray-300 leading-relaxed">
                NO 1 CLOBEK ESTATE<br />
                LUGBE, ABUJA<br />
                FCT, Nigeria
              </p>
            </div>
            <div className="bg-white/10 backdrop-blur-lg p-8 rounded-3xl text-center text-white hover:bg-white/15 transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-primary-500/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="fas fa-phone text-primary-500 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold mb-4">Call Us</h3>
              <p className="text-gray-300 leading-relaxed">
                09030029981<br />
                Mon-Sat: 8AM-6PM
              </p>
            </div>
            <div className="bg-white/10 backdrop-blur-lg p-8 rounded-3xl text-center text-white hover:bg-white/15 transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-primary-500/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="fas fa-list-check text-primary-500 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold mb-4">Our Services</h3>
              <p className="text-gray-300 leading-relaxed">
                Baking<br />
                Catering Services<br />
                General Contracts
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-4 md:mb-0">
              <p className="text-gray-400">&copy; 2024 Seven Cakes & Treats. All rights reserved.</p>
            </div>
            <div className="flex space-x-6">
              <a href="#" className="w-10 h-10 bg-primary-500/20 rounded-xl flex items-center justify-center text-primary-500 hover:bg-primary-500 hover:text-white transition-all duration-300">
                <i className="fab fa-facebook"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-primary-500/20 rounded-xl flex items-center justify-center text-primary-500 hover:bg-primary-500 hover:text-white transition-all duration-300">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-primary-500/20 rounded-xl flex items-center justify-center text-primary-500 hover:bg-primary-500 hover:text-white transition-all duration-300">
                <i className="fab fa-whatsapp"></i>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default App;